import React, {useEffect} from 'react';
import styled from "styled-components";
import {auth, provider, signInWithPopup, signOut} from "../firebase";
import {useDispatch, useSelector} from "react-redux";
import {Link, useNavigate} from "react-router-dom";
import {selectUserName, selectUserEmail, selectUserPhoto,
    setSignOutState, setUserLoginDetails} from "../features/userSlice";

function Header(props) {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const userName = useSelector(selectUserName)
    const userEmail = useSelector(selectUserEmail)
    const userPhoto = useSelector(selectUserPhoto)
    const handleAuth = () => {
        if(!userName){
            signInWithPopup(auth, provider).then((response) => {
                setUser(response.user)
            }).catch((error) => alert(error.message))
        } else if(userName){
            signOut(auth).then(() => {
                dispatch(setSignOutState())
                navigate('/')
            }).catch(error => alert(error.message))
        }

    }

    const setUser = (user) => {
        dispatch(setUserLoginDetails({
            name: user.displayName,
            email: user.email,
            photo: user.photoURL
        }))
    }

    useEffect(() => {
        auth.onAuthStateChanged(async (user) => {
            if(user){
                setUser(user)
                navigate('/home')
            }
        })
    }, [userName])
    return (
        <Nav>
            <Logo>
                <img src="./images/logo.svg" alt="LOGO"/>
            </Logo>

            {
                !userName ?
                <Login onClick={handleAuth}>login</Login>
                :
                <>
                    {/*<NavMenu>*/}
                    {/*    <a href="/home">*/}
                    {/*        <img src="./images/home-icon.svg" alt="HOME"/>*/}
                    {/*        <span>home</span>*/}
                    {/*    </a>*/}
                    {/*    <a href="/home">*/}
                    {/*        <img src="./images/search-icon.svg" alt="SEARCH"/>*/}
                    {/*        <span>search</span>*/}
                    {/*    </a>*/}
                    {/*    <a href="/home">*/}
                    {/*        <img src="./images/watchlist-icon.svg" alt="WISHLIST"/>*/}
                    {/*        <span>watchlist</span>*/}
                    {/*    </a>*/}
                    {/*    <a href="/home">*/}
                    {/*        <img src="./images/original-icon.svg" alt="ORIGINAL"/>*/}
                    {/*        <span>originals</span>*/}
                    {/*    </a>*/}
                    {/*    <a href="/home">*/}
                    {/*        <img src="./images/movie-icon.svg" alt="MOVIES"/>*/}
                    {/*        <span>movies</span>*/}
                    {/*    </a>*/}
                    {/*    <a href="/home">*/}
                    {/*        <img src="./images/series-icon.svg" alt="SERIES"/>*/}
                    {/*        <span>series</span>*/}
                    {/*    </a>*/}

                    {/*</NavMenu>*/}

                    <NavMenu>
                        <Link to="/home">
                            <img src="./images/home-icon.svg" alt="HOME"/>
                            <span>home</span>
                        </Link>
                        <Link to="/home">
                            <img src="./images/search-icon.svg" alt="SEARCH"/>
                            <span>search</span>
                        </Link>
                        <Link to="/home">
                            <img src="./images/watchlist-icon.svg" alt="WISHLIST"/>
                            <span>watchlist</span>
                        </Link>
                        <Link to="/home">
                            <img src="./images/original-icon.svg" alt="ORIGINAL"/>
                            <span>originals</span>
                        </Link>
                        <Link to="/home">
                            <img src="./images/movie-icon.svg" alt="MOVIES"/>
                            <span>movies</span>
                        </Link>
                        <Link to="/home">
                            <img src="./images/series-icon.svg" alt="SERIES"/>
                            <span>series</span>
                        </Link>

                    </NavMenu>
                    <SignOut>
                        <UserImg src={userPhoto} alt={userName} referrerpolicy="no-referrer"/>
                        <DropDown>
                            <span onClick={handleAuth}>SignOut</span>
                        </DropDown>
                    </SignOut>
                </>
            }
        </Nav>
    );
}

const Nav = styled.nav`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 70px;
    background-color: #090b13;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 36px;
    z-index: 3;
    letter-spacing: 16px;
`

const Logo = styled.a`
    padding: 0;
    width: 80px;
    margin-top: 4px;
    font-size: 0;
    max-height: 70px;
    display: inline-block;
    img{
        display: block;
        width: 100%;
    }
`

const NavMenu = styled.div`
    height: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: center;
    margin: 0;
    padding: 0;
    position: relative;
    margin-right: auto;
    margin-left: 25px;
    
    @media screen and (max-width: 768px){
        display: none;
    }
    
    a{
        display: flex;
        align-items: center;
        margin: 0 12px;
        img{
            height: 20px;
            min-width: 20px;
            width: 20px;
            z-index: auto;
        }
        
        span{
            text-transform: uppercase;
            color: rgb(249, 249, 249);
            font-size: 13px;
            letter-spacing: 1.42px;
            line-height: 1.08;
            padding: 2px 0;
            white-space: nowrap;
            position: relative;
            
            &:before{
                content: "";
                background-color: rgb(249, 249, 249);
                // opacity: 0;
                position: absolute;
                bottom: -6px;
                left: 0px;
                right: 0px;
                height: 2px;
                width: auto;
                border-radius: 0 0 4px 4px;
                transform: scaleX(0);
                transform-origin: left center;
                transition: all 250ms ease-in-out;
                visibility: hidden;
            }
            
            &:hover{
                &:before{
                    transform: scaleX(1);
                    visibility: visible;
                    opacity: 1;
                }
            }
        }    
    }
`

const Login = styled.a`
    text-transform: uppercase;
    background-color: rgba(0,0,0,0.6);
    border: 1px solid #f9f9f9;
    padding: 8px 16px;
    letter-spacing: 1.5px;
    border-radius: 4px;
    transition: all 0.3s ease 0s;
    font-weight: 600;
    &:hover{
        background-color: #f9f9f9;
        color: #000;
        border-color: transparent;
    }
`

const UserImg = styled.img`
    // height: 50px;
    // width: 50px;
    height: 100%;
`

const DropDown = styled.div`
    position: absolute;
    top: 48px;
    right: 0px;
    background: rgb(19, 19, 19);
    padding: 10px;
    border: 1px solid rgba(151, 151, 151, 0.34);
    border-radius: 4px;
    box-shadow: rgb(0 0 0 / 50%) 0px 0px 18px 0px;
    letter-spacing: 3px;
    font-size: 14px;
    width: 100px;
    opacity: 0;
`

const SignOut = styled.div`
    position: relative;
    width: 48px;
    height: 48px;
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    ${UserImg}{
        border-radius: 50%;
        width: 100%;
        height: 100%;
    }
    
    &:hover{
        ${DropDown}{
            transition-duration: 1s;
            opacity: 1;
        }
    }
`

export default Header;